'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LayoutSectionCustomDragLayer from 'InpageEditorUI/components/LayoutSectionCustomDragLayer';
import LayoutSectionDragDomManipulationContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionDragDomManipulationContainer';
import LayoutSectionDragLayerContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionDragLayerContainer';
import LayoutSectionDropTargetsContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionDropTargetsContainer';
import LayoutSectionResizeHandleContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionResizeHandleContainer';
import LayoutSectionGridContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionGridContainer';
import LayoutSectionSelectedNodeContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionSelectedNodeContainer';
import { getAllLayoutSectionTreesAsMap, getHasAnyLayoutSections } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { layoutSectionHoverPositionsCleared } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import LayoutSectionNopeZoneContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionNopeZoneContainer';
import { getFeatureFlag } from 'ContentEditorUI/redux/selectors/featureFlagsSelectors';
import { FEATURE_FLAGS } from 'ContentEditorUI/redux/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    hasAnyLayoutSections: getHasAnyLayoutSections(state),
    layoutSectionTrees: getAllLayoutSectionTreesAsMap(state),
    shouldUseNopeZonesForAllModules: getFeatureFlag(FEATURE_FLAGS.shouldUseNopeZonesForAllModules)
  };
};
class LayoutSectionContainer extends Component {
  constructor(props) {
    super(props);
    this.handleHoverOutOfInpage = this.handleHoverOutOfInpage.bind(this);
  }
  componentDidMount() {
    const {
      bus,
      hasAnyLayoutSections
    } = this.props;
    if (hasAnyLayoutSections) {
      bus.on('post:hoverOutOfInpage', this.handleHoverOutOfInpage.bind(this));
    }
  }
  handleHoverOutOfInpage() {
    const {
      tour
    } = this.context;
    const currentStep = tour ? tour.getStep() : '';
    if (currentStep !== 'resizeColumn' && currentStep !== 'sectionDropdown') {
      this.props.layoutSectionHoverPositionsCleared();
    }
  }
  render() {
    const {
      bus,
      hasAnyLayoutSections,
      shouldUseNopeZonesForAllModules
    } = this.props;
    if (!hasAnyLayoutSections) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(LayoutSectionDragLayerContainer, {
        dispatchActionToEventBus: bus.dispatchActionToEventBus
      }), /*#__PURE__*/_jsx(LayoutSectionDropTargetsContainer, {}), /*#__PURE__*/_jsx(LayoutSectionResizeHandleContainer, {}), /*#__PURE__*/_jsx(LayoutSectionDragDomManipulationContainer, {}), /*#__PURE__*/_jsx(LayoutSectionCustomDragLayer, {}), /*#__PURE__*/_jsx(LayoutSectionGridContainer, {}), /*#__PURE__*/_jsx(LayoutSectionSelectedNodeContainer, {}), !shouldUseNopeZonesForAllModules && /*#__PURE__*/_jsx(LayoutSectionNopeZoneContainer, {})]
    });
  }
}
LayoutSectionContainer.propTypes = {
  bus: PropTypes.object.isRequired,
  hasAnyLayoutSections: PropTypes.bool.isRequired,
  layoutSectionHoverPositionsCleared: PropTypes.func.isRequired,
  shouldUseNopeZonesForAllModules: PropTypes.bool.isRequired
};
LayoutSectionContainer.contextType = TourContext;
export default connect(mapStateToProps, {
  layoutSectionHoverPositionsCleared
})(LayoutSectionContainer);